import * as React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import Section from 'src/components/Section'

import * as style from './style.module.css'
import * as grid from 'src/css/grid.module.css'
import Benefit, { BenefitType } from './Benefit'

export default function Benefits({
  benefits,
  large,
  two,
  three,
  four,
}) {
  return (
    <Section withPadding>
      <div
        className={cn(
          style.container,
          large && style.large,
          two && grid.two,
          three && grid.three,
          four && grid.four
        )}
      >
        {benefits?.length &&
          benefits.map(benefit => (
            <Benefit
              key={benefit.title}
              title={benefit.title}
              image={benefit.image}
              description={benefit.description}
            />
          ))}
      </div>
    </Section>
  )
}

export const BenefitsType = {
  benefits: PropTypes.arrayOf(PropTypes.shape(BenefitType)),
  large: PropTypes.bool,
  two: PropTypes.bool,
  three: PropTypes.bool,
  four: PropTypes.bool,
}

Benefits.propTypes = BenefitsType
